import { render } from "./App.vue?vue&type=template&id=b8820afa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b8820afa&lang=css"

import exportComponent from "D:\\weixin_repair\\ideamerry_open_repair_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__